import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false
}: CardProps) {
  return <div className={`bg-dark-surface border-2 border-dark-border rounded-industrial p-6 ${hover ? 'transition-all duration-200 hover:border-brand-yellow' : ''} ${className}`} data-id="element-557">
      {children}
    </div>;
}